import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export default styled(Paper)(({ theme }) => ({
  backgroundColor: '#404040',
  ...theme.typography.body2,
  color: theme.palette.text.primary,
  border: 'none',
  boxShadow: 'none',
  justifyContent: 'center'
}));
